import React from 'react';
import { Alert, Progress, Row, Space, Tag, Typography } from 'antd';
import { formatPercent } from '../../../utils/format';

const { Text } = Typography;

const resourceErrors: Record<string, string> = {
  not_found: 'No data available for this domain.',
  invalid_key: 'Similarweb API key is invalid or inactive.',
  access_denied: 'Your Similarweb subscription does not allow access to this data.',
  date_unavailable: 'Similarweb data is not yet available for the requested months.',
};

export type TrafficSourceRow = {
  label: string;
  value: number;
};

const resourceMessage = (error?: string) => (
  <Alert
    type="warning"
    showIcon
    message={resourceErrors[error || ''] || 'Similarweb data is temporarily unavailable.'}
  />
);

export const TrafficSourcesCard: React.FC<{ trafficSources: TrafficSourceRow[]; error?: string }> = ({ trafficSources, error }) => (
  <section className="leadops-resource-section">
    <Text strong className="leadops-resource-title">Traffic Sources</Text>
    {trafficSources.length === 0 && error && resourceMessage(error)}
    {trafficSources.length === 0 && !error && <Text type="secondary">No data returned.</Text>}
    {trafficSources.length > 0 && (
      <Space direction="vertical" size={10} style={{ width: '100%' }}>
        {trafficSources.map((item) => (
          <div key={item.label}>
            <Row justify="space-between" align="middle">
              <Text>{item.label}</Text>
              <Tag color="green">{formatPercent(item.value)}</Tag>
            </Row>
            <Progress
              percent={Math.min(100, Math.max(0, item.value))}
              showInfo={false}
              strokeColor="#3f8600"
              strokeWidth={6}
            />
          </div>
        ))}
      </Space>
    )}
  </section>
);

export const CompetitorsCard: React.FC<{ competitors: any[]; error?: string }> = ({ competitors, error }) => (
  <section className="leadops-resource-section">
    <Text strong className="leadops-resource-title">Competitors</Text>
    {competitors.length === 0 && error && resourceMessage(error)}
    {competitors.length === 0 && !error && <Text type="secondary">No data returned.</Text>}
    {competitors.length > 0 && (
      <Space direction="vertical" size={8} style={{ width: '100%' }}>
        {competitors.map((item: any, index: number) => (
          <Row key={item.url || item.site || item.domain || item.name || index} align="middle" justify="space-between">
            <Text>{item.url || item.site || item.domain || item.name || `Competitor ${index + 1}`}</Text>
            <Tag color="blue">Top {index + 1}</Tag>
          </Row>
        ))}
      </Space>
    )}
  </section>
);
